import { isDefined } from "utils/validation"
import { http } from "services/http"

import jsonpipe from "jsonpipe/jsonpipe"

export const getJsonPipeFlow = async ({
    apiRoute, 
    onProgress, 
    onComplete, 
    onError,
    utils
}) => {

    if (!utils?.logout) throw new Error("No auth logout provided") 
    
    const token = await http.getToken({
        logout: utils?.logout,
        alert: utils?.alert
    })

    if (!token) throw new Error("No access token") 
    
    jsonpipe.flow(apiRoute, {
        "delimiter": "\n",

        "success": (data) => {
            if (isDefined(onProgress)) onProgress(data)
        },

        "error": (errorMsg) => {
            if (isDefined(onError)) onError(errorMsg)
        },

        "complete": (statusText) => {
            if (isDefined(onComplete)) onComplete(statusText)
        },

        "timeout": 3000, // Number. Set a timeout (in milliseconds) for the request
        "method": "GET", // String. The type of request to make (e.g. "POST", "GET", "PUT"); default is "GET"
        "headers": { "Authorization": "Bearer " + token },
        "data": "", // String | FormData | File | Blob. What to be sent in the request body.
        "withCredentials": false
    })
}
  